<template>
  <div class="introduce">
    <div class="bigImg"></div>
    <div class="box">
      <img src="../../static/introduce/ldj.jpg" alt="">
      <img src="../../static/introduce/ldy.jpg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name:'introduce',
}
</script>

<style lang="less" scoped>
  .introduce{
    width: 100%;
    .bigImg{
      width: 100%;
      height: 500px;
      background: url('../../static/introduce/banner.jpg') no-repeat;
      background-size: cover;
    }
    .box{
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      padding: 50px 0;
      img{
        margin: 30px auto;
      }
    }
  }
</style>